'use strict';

/**
 * BD.MoG: Handle Month of Giving UI
 */
var BD = window.BD = window.BD || {};
BD.MoG = (function($) {
  var $mog;
  var $mogOptionContainer;
  var submitCounter = 0;
  
  function refreshDisplay() {
    $mog.find('.mog__charity').removeClass('selected');
    
    var $selectedInput = $mog.find('input:checked');
    $selectedInput.closest('.mog__charity').addClass('selected');
    
    var hasSelected = !!$selectedInput.length;
    
    if (hasSelected) {
      CartJS.setAttribute('charity', $selectedInput.prop('value'));
    }
    
    $mogOptionContainer.toggleClass('error', !hasSelected);
  }

  function submit(e) {
    var selected = CartJS.getAttribute('charity');
    
    if (!selected && submitCounter++ < 3) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $mogOptionContainer.offset().top
      }, 500);

      $mogOptionContainer.addClass('error');
    }
  }
  
  function init() {
    $mog = $('.cartOption--mog');
    if (!$mog.length) { return; }
    
    $mogOptionContainer = $('.cartOption--mog');
    
    $mog.find('input').on('change', refreshDisplay);
    $('.btn--nextStep').on('click', submit);
    
    var selectedCharity = CartJS.getAttribute('charity', null);

    $mog.find('input').filter((idx, el) => el.value == selectedCharity).prop('checked', true);
    refreshDisplay();
    
    // refreshDisplay will show the "field required" error, but we don't want it shown until submission
    $mogOptionContainer.removeClass('error');
  }
  
  $(document).on('cart.ready', init);
})(jQuery);